/**
 * Utilidades de normalización para el formulario de políticas
 * (textos configurables con identificador libre).
 */

/**
 * Descodifica las secuencias de escape Unicode literales (u seguida de cuatro
 * dígitos hexadecimales) que aparecen cuando se pega texto copiado de una
 * respuesta JSON de la API: las convierte en el carácter que representan.
 * Si el texto no contiene escapes, se devuelve tal cual.
 */
export const decodeUnicodeEscapes = (value) => {
  if (typeof value !== "string" || !value.includes("\\u")) {
    return value;
  }

  return value.replace(/\\u([0-9a-fA-F]{4})/g, (_match, hex) =>
    String.fromCharCode(Number.parseInt(hex, 16)),
  );
};

/** Pone en mayúscula la primera letra del texto. */
export const capitalizeFirstLetter = (value) => {
  if (typeof value !== "string" || value.length === 0) {
    return value;
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
};

/**
 * Normaliza el identificador (type): descodifica escapes, recorta los espacios
 * sobrantes y pone la primera letra en mayúscula ("política" -> "Política").
 * Se usa al enviar el formulario; mientras se escribe no se recorta para no
 * interferir con la introducción de identificadores de varias palabras.
 */
export const normalizePolicyType = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  return capitalizeFirstLetter(decodeUnicodeEscapes(value).trim());
};

/** Normaliza un mapa de textos localizados ({ idioma: texto }). */
export const normalizeLocalizedTexts = (texts) => {
  if (!texts || typeof texts !== "object") {
    return texts;
  }

  return Object.fromEntries(
    Object.entries(texts).map(([language, text]) => [
      language,
      decodeUnicodeEscapes(text),
    ]),
  );
};

export default {
  decodeUnicodeEscapes,
  capitalizeFirstLetter,
  normalizePolicyType,
  normalizeLocalizedTexts,
};
